import { render, staticRenderFns } from "./BackVlogType.vue?vue&type=template&id=aabdb376&scoped=true"
import script from "./BackVlogType.vue?vue&type=script&lang=js"
export * from "./BackVlogType.vue?vue&type=script&lang=js"
import style0 from "./BackVlogType.vue?vue&type=style&index=0&id=aabdb376&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aabdb376",
  null
  
)

export default component.exports